import { StyleSheet } from 'react-native'

export default StyleSheet.create({
  container: {
    marginVertical: 20 // 64,
  },
})
